/**
 * @documental
 * @export Placeholder
 * @name
 * SubmitGroup.Placeholder
 */

import { FC, ReactNode, PropsWithChildren } from "react";
import { useSubmitting } from "./useSubmitting";

/**
 * The `Placeholder` component properties.
 */
export interface PlaceholderProps {

  /**
   * The fallback content to display if submitting.
   */
  readonly fallback: ReactNode;
}

/**
 * A component which renders fallback content instead of its children if submitting.
*/
export const Placeholder: FC<PropsWithChildren<PlaceholderProps>> = (props) => {
  const { fallback, children } = props;
  const submitting = useSubmitting();

  if (submitting) {
    return <>{fallback}</>;
  } else {
    return <>{children}</>;
  }
};
